import React from 'react';
import { useTranslation } from 'react-i18next';

/**
 * Tiny KPI strip used at the top of each Settings tab. Three tiles max.
 *
 * Each tile is { label, value, icon, tone } where `tone` is one of
 * 'accent' | 'green' | 'amber' | 'purple' (matches sadmin-kpi-icon variants).
 */
const KpiStrip = ({ tiles = [] }) => {
    const { t } = useTranslation();
    if (!tiles.length) return null;
    return (
        <div className="v3-sadmin-kpis">
            {tiles.map((tile, idx) => (
                <div key={idx} className="v3-card v3-sadmin-kpi">
                    <div className="v3-sadmin-kpi-top">
                        <span className="v3-label">{t(tile.label)}</span>
                        {tile.icon ? (
                            <span className={`v3-sadmin-kpi-icon ${tile.tone || 'accent'}`}>{tile.icon}</span>
                        ) : null}
                    </div>
                    <div className="v3-sadmin-kpi-value">{tile.value}</div>
                </div>
            ))}
        </div>
    );
};

export default KpiStrip;
